/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelEnumInterfaces.mustache
// synched 02.02.2023
import * as yup from 'yup';
import * as fastJSON from 'fast-json-stringify';
import { StringSchema } from 'fast-json-stringify';
/**
 *
 * @export
 * @enum {string}
 */
export enum LightlyTrainerPrecisionV3 {
    NUMBER_16 = 16,
    NUMBER_32 = 32
}
/* LIGHTLY CUSTOM START -> modelEnumInterfaces */
export const LightlyTrainerPrecisionV3ValidatorShape = [
    16,
    32
];
export const LightlyTrainerPrecisionV3Validator = yup.mixed().oneOf(LightlyTrainerPrecisionV3ValidatorShape);
export const LightlyTrainerPrecisionV3StringifyShapeProperties = {};
export const LightlyTrainerPrecisionV3StringifyShape: StringSchema = {
    title: 'LightlyTrainerPrecisionV3 Stringifier',
    type: 'string'
};
export const LightlyTrainerPrecisionV3Stringify = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(LightlyTrainerPrecisionV3StringifyShape)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
/* LIGHTLY CUSTOM END */
export function LightlyTrainerPrecisionV3FromJSON(json: any): LightlyTrainerPrecisionV3 {
    return LightlyTrainerPrecisionV3FromJSONTyped(json, false);
}
export function LightlyTrainerPrecisionV3FromJSONTyped(json: any, ignoreDiscriminator: boolean): LightlyTrainerPrecisionV3 {
    return json as LightlyTrainerPrecisionV3;
}
export function LightlyTrainerPrecisionV3ToJSON(value?: LightlyTrainerPrecisionV3 | null): any {
    return value as any;
}
